import React from 'react';
import { useUser } from '@lore/auth';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import Form from './Form';
import { Helmet } from 'react-helmet-async';
import useRouter from '../../../hooks/useRouter';
import useSetupNavigation from '../useSetupNavigation';

export default function Layout(props) {
  const { history } = useRouter();
  const user = useUser();

  const navigation = useSetupNavigation(Urls.NAME_CONTACT);

  return (
    <ParentLayout>
      <Helmet>
        <title>Setup - Name</title>
      </Helmet>
      <Form
        user={user}
        navigation={navigation}
        onPrevious={(newData) => history.push(Urls.NETWORK)}
        onNext={(newData) => history.push(Urls.ZIP_CODE)}
        onSkip={() => history.push(Urls.ZIP_CODE)}
      />
    </ParentLayout>
  );
};
